import React from 'react';
import { State, OnActionArgs, OnEnterArgs } from '..';
import { KeysOfType } from 'component_utils/typescriptUtils';
import Translation from 'utils/Language/Translation';
import { isNil } from 'lodash';
import { addNotification } from 'utils/NotificationManager';

type Find<S, P, R, T> = (state: OnActionArgs<S, P, R>) => Promise<T>;
type PreFind<S, P, R, T> = (state: OnEnterArgs<S, P, R>) => Promise<T>;

interface EventProps {
}

interface Config<S, P, A, R, T> {
  nextState: number;
  targetKey: KeysOfType<S, T>;
  find: Find<S, P, R, T>;
  preFind?: PreFind<S, P, R, T>;
  attributes?: Partial<A>;
  skipOnAlreadySet?: boolean;
}

const StateFindAny = function <S, P extends EventProps, A extends { hint: string }, R, T>({
  nextState,
  targetKey,
  find,
  preFind,
  attributes = {},
  skipOnAlreadySet = true
}: Config<S, P, A, R, T>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      if (!isNil(args.state[targetKey]) && skipOnAlreadySet) {
        return {
          type: 'MOVE',
          data: {} as any,
          nextState,
        };
      }

      if (preFind) {
        const found = await preFind(args);
        if (found !== undefined) {
          return {
            type: 'MOVE',
            data: {
              [targetKey]: found,
            } as any,
            nextState,
          };
        }
      }
    },
    onAction: async (args) => {
      const found = await find(args);
      if (found === null || found === undefined) {
        throw addNotification('danger', <Translation name="T.errors.notFound" />);
      }
      return {
        type: 'MOVE',
        data: {
          [targetKey]: found,
        } as any,
        nextState,
      };
    },
    attributes: {
      hint: 'T.hints.location',
      ...(attributes as any),
    },

    nodeName: 'T.states.findAny',
    outputs: [
      {
        name: 'onScan',
        to: nextState,
      },
    ],
  };
};

export default StateFindAny;
